import { createStore } from "./createStore";
import { debugLog } from "@/utils/debugLog";

const base = (set, get) => ({
  annotations: [],
  setAnnotations: (annotations) => set({ annotations }),
  arrows: [],
  setArrows: (arrows) => set({ arrows }),
  emphasized: [],
  setEmphasized: (emphasized) => set({ emphasized }),
  clearAllAnnotations: () => {
    debugLog("Clearing all annotations");
    const state = get();

    // Clear annotations
    state.annotations.forEach(({ annotation }) => {
      if (annotation) {
        annotation.remove();
      }
    });

    // Clear arrows
    state.arrows.forEach(({ svg }) => {
      if (svg) {
        svg.remove();
      }
    });

    // Clear emphasized elements
    state.emphasized.forEach(({ element }) => {
      const emphasizeElement = document.getElementById(element);
      if (emphasizeElement) {
        const svg = emphasizeElement.querySelector(".emphasize-svg");
        if (svg) {
          svg.remove();
        }
      }
    });

    // Reset all states
    set({
      annotations: [],
      arrows: [],
      emphasized: [],
    });
  },
});

export const useAnnotationStore = createStore("AnnotationStore", base);
